import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=c8b8277e&scoped=true"
import script from "./Competition.vue?vue&type=script&lang=js"
export * from "./Competition.vue?vue&type=script&lang=js"
import style0 from "./Competition.vue?vue&type=style&index=0&id=c8b8277e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b8277e",
  null
  
)

export default component.exports